const getYearsAndMonths = (totalMonths) => {
  let yearsMonths = "";
  const years = Math.floor(totalMonths / 12);
  const months = Math.floor(totalMonths % 12);
  if (years > 0) {
    yearsMonths += `${years} year`;
    if (years > 1) yearsMonths += "s";
    if (months > 0) yearsMonths += " and ";
  }
  if (months > 0) {
    yearsMonths += `${months} month`;
    if (months > 1) yearsMonths += "s";
  }
  return yearsMonths;
};
const formatLocaleString = (amount) => amount.toLocaleString("en", {
  style: "currency",
  currency: "USD",
  minimumFractionDigits: 0,
  maximumFractionDigits: 0
});
const currencyFormatter = (num, digits) => {
  const lookup = [{
    value: 1,
    symbol: ""
  }, {
    value: 1e3,
    symbol: "k"
  }, {
    value: 1e6,
    symbol: "M"
  }, {
    value: 1e9,
    symbol: "B"
  }, {
    value: 1e12,
    symbol: "T"
  }];
  const rx = /\.0+$|(\.[0-9]*[1-9])0+$/;
  const item = lookup.slice().reverse().find((elem) => Math.abs(num) >= elem.value);
  return item ? (Math.abs(num) / item.value).toFixed(digits).replace(rx, "$1") + item.symbol : "0";
};
export {
  currencyFormatter,
  formatLocaleString,
  getYearsAndMonths
};
